import React from "react";
import PropTypes from "prop-types";
import Framework from "@beardeddevops/react.framework";

export default class UniversalModalOverride extends Framework.Elements.UniversalModal {
	static propTypes = {
		...super.propTypes,
		locations: PropTypes.array.isRequired,
		states: PropTypes.array.isRequired,
		kiosks: PropTypes.array,
		account: PropTypes.string,
		keepOpen: PropTypes.bool,
		setKeepOpen: PropTypes.func
	};
	toggleClose = () => {
		if (this.props.handleToggle) {
			this.props.handleToggle();

			return;
		}
		if(!this.props.keepOpen){
			this.setState({showModal: false}, () => {
				this.props.reportClose();
			});
		}
		// this.props.setKeepOpen()
	}
	render() {
		this.additionalProps = {
			locations: this.props.locations,
			states: this.props.states,
			kiosks: this.props.kiosks,
			account: this.props.account,
		};


		return super.render();
	}
}
